
import React from "react";
import JournalEntryCard from "./JournalEntryCard";
import JournalEntrySkeleton from "@/components/journal/JournalEntrySkeleton";
import { JournalEntry } from "@/hooks/journal/types";

interface JournalEntriesListProps {
  journalEntries: JournalEntry[];
  loading: boolean;
  isDeleting: boolean;
  entryToDelete: string | null;
  onViewEntry: (entryId: string) => void;
  onDeleteEntry: (entryId: string) => void;
}

const JournalEntriesList: React.FC<JournalEntriesListProps> = ({
  journalEntries,
  loading,
  isDeleting,
  entryToDelete,
  onViewEntry,
  onDeleteEntry
}) => {
  if (loading) {
    return (
      <div className="space-y-4">
        {[...Array(3)].map((_, i) => (
          <JournalEntrySkeleton key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {journalEntries.map((entry) => (
        <JournalEntryCard
          key={entry.id}
          entry={entry}
          onView={onViewEntry}
          onDelete={onDeleteEntry}
          isDeleting={isDeleting}
          entryToDelete={entryToDelete}
        />
      ))}
    </div>
  );
};

export default JournalEntriesList;
